import React from 'react';
import { Link } from 'react-router';
import { header } from 'constants/table';
import DataTable from 'components/data-table';
import { connect } from 'react-redux';
import { API_URL } from 'constants/config';
import { RowItemDanhSachDoiTuongTrung } from 'modules/thanh-tra/datatable';
import { Input, DropDown } from 'components/tt-forms/common';
import { ThanhTra } from 'api';

class DanhSachDoiTuongTrung extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      namThanhTraList: [],
      namThanhTra: (new Date().getFullYear() + 1).toString(),
      tenDoiTuongThanhTra: '',
      donViId: '',
      donViChuTriList: [],
      loading: false,
      loadingSearch: false
    }
  }

  componentDidMount() {
    let data = localStorage.getItem('dttData') ? JSON.parse(localStorage.getItem('dttData')) : {};
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.namThanhTra = this.props.goBack ? data.namThanhTra : (new Date().getFullYear() + 1).toString();
    this.state.tenDoiTuongThanhTra = data.tenDoiTuongThanhTra || '';
    this.getDataList();
    this.getNamThanhTraList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.namThanhTra !== prevProps.namThanhTra) {
      this.forceUpdate();
    }
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViKHTT.request().then(res => {
      if (res.data && res.data._embedded) {
        res.data._embedded.coQuanQuanLies.map((item) => {
          this.state.donViChuTriList.push({value: item.coQuanQuanLyId, label: item.ten});
        });
      } else {
        this.state.donViChuTriList = [];
      }
      this.setState({...this.state});
    });
  }

  getDataList(isFirst) {
    if (isFirst) {
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
    }
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size
    }

    if (this.state.namThanhTra) {
      params.namThanhTra = this.state.namThanhTra ? this.state.namThanhTra : new Date().getFullYear() + 1;
    }

    if (this.state.tenDoiTuongThanhTra) {
      params.tenDoiTuongThanhTra = this.state.tenDoiTuongThanhTra;
    }
    this.setState({loading: true});
    localStorage.setItem('dttData', JSON.stringify(params));
    ThanhTra.actions.getCuocThanhTraTrung.request(null, params).then(res => {
     if (res.data._embedded) {
        this.setState({
          data: res.data._embedded.medial_CuocThanhTraTrungInfoes,
          pageData: res.data.page,
          loading: false
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          loading: false
        });
      }
    });
    this.props.dispatch({type:'DSTT_RESET_GO_BACK'})
  }

  onChange(name, e) {
    let value = e.target ? e.target.value : e;
    this.setState({
      [name]: value
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getDataList();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getDataList();
  }

  getNamThanhTraList() {
    if (this.props.namThanhTra.length === 0) {
      ThanhTra.actions.getNamThanhTra.request().then(res => {
        if (res.data) {
          this.props.dispatch({type:'SET_NAM_THANH_TRA', data: res.data})
        }
      });
    }
  }

  handleExport() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

      let URL = String(API_URL) + "/cuocThanhTraTrungDoiTuong/xuatExcel?tenDoiTuongThanhTra=" + this.state.tenDoiTuongThanhTra
      + "&namThanhTra=" + (this.state.namThanhTra ? this.state.namThanhTra : '');

      window.open(URL, "_self");
  }

  render() {
    return (
      <div className="center reception-container">
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách đối tượng thanh tra trùng</p>
          </div>
        </div>
        <div className="bottom-content">
          <div className='wrap-block pl15 pr15 pt20'>
            <div className='row pl10 pr10'>
              <Input className='col-40 mb0-18' label='Đối tượng thanh tra' placeholder='Nhập tên đối tượng...' value={this.state.tenDoiTuongThanhTra} onChange={this.onChange.bind(this, 'tenDoiTuongThanhTra')}/>
              <DropDown className='input-group mb0-18' label='Năm thanh tra' options={this.props.namThanhTra} keyName="giaTri" valueName="ten" selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} placeholder/>
              <div className='input-group mb0-18 search-thanh-tra'>
                <Link className={`btn-green ${this.state.loadingSearch ? 'btn-loading-inline' : ''}`} onClick={this.getDataList.bind(this, true)}>
                  <i className='tt-search'></i>Tìm kiếm
                </Link>
              </div>
            </div>
            <div className='row pt20'>
              <span className="line-border"></span>
            </div>
          </div>
          <DataTable
            header={ header.thanhTra.DSDTT }
            handleExport={this.handleExport.bind(this)}
            dataList={ this.state.data }
            exporttext="Xuất báo cáo"
            hideButtonExport={true}
            thanhTra
            pageData={ this.state.pageData }
            parent={ this }
            search={true}
            tableLoading={ this.state.loading }>
            <RowItemDanhSachDoiTuongTrung/>
          </DataTable>
        </div>
      </div>
    );
  }
}

DanhSachDoiTuongTrung.defaultProps = {
  validators: {},
  goBack: false,
  namThanhTra: []
}

const mapStateToProps = function(state) {
  return {
    goBack: state.danhSachKHThanhTra.goBack,
    namThanhTra: state.danhSachKHThanhTra.namThanhTra
  }
}

export default connect(mapStateToProps)(DanhSachDoiTuongTrung);



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/DanhSachDoiTuongTrung.jsx